module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "table-ref": "utilrpttable",
      "title": _vm.utilLabel + ' Bill Report',
      "icon": "fa fa-plug",
      "url": "/report/utility/summary",
      "fields": _vm.fields,
      "sort-field": "siteName",
      "show-refresh": false,
      "show-search": false,
      "detail-component": "util-report-detail"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cabd069"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/utility/UtilityReport.vue
// module id = 1588
// module chunks = 0